export const CUSTOMER_TOKEN = 'CUSTOMER_TOKEN';
export const  AUTHENTICATED = 'AUTHENTICATED';
export const  ROLE = 'ROLE';
export const LIMIT = 'LIMIT';
